import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberEndorsementForm from '../../../components/forms/MemberEndorsementForm';
import { useMemberEndorsementApi } from '../../../hooks/useMemberEndorsementApi';
import { useNavigate, useParams } from 'react-router-dom';
import { MemberEndorsementDTO } from '../../../services/apiClient';

const MemberEndorsementEdit: React.FC = () => {
  const { getById, edit } = useMemberEndorsementApi();
  const [entityData, setEntityData] = useState<MemberEndorsementDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Endorsements', href: '/admin/memberendorsements' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching MemberEndorsement data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate(-1);
    } catch (error) {
      console.error('Error updating MemberEndorsement:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberendorsements"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission='Manage.MemberEndorsement.Edit'
    >
      {entityData ? (
        <MemberEndorsementForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default MemberEndorsementEdit;